import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortModal } from "app/components";
import { CONSTANTS } from "app/constants";
import { DrawingClubWCGroupBasketsDto, DrawingEuroGroupResponseDto, DrawingEuroPlayoffResultDto, TeamShortDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawing-cwc-group',
    templateUrl: './drawing-club-wc-group.component.html',
    styleUrls: ['./drawing-club-wc-group.component.scss'],
})
export class DrawingClubWCGroup implements OnInit {
    const;

    matchDay1: number;
    matchDay2: number;
    matchDay3: number;
    
    @Input()
    dto: DrawingClubWCGroupBasketsDto;


    basketNumbers = [1, 2, 3, 4];

    baskets: any[] = [];
    
    constructor(private modalService: NgbModal, private notificationService: NotificationService, 
        private drawingService: DrawingsService) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.baskets.push(this.dto.basket1);
        this.baskets.push(this.dto.basket2);
        this.baskets.push(this.dto.basket3);
        this.baskets.push(this.dto.basket4);
    }

    onChangeTeam(team: number, basketNumber: number, index: number) {
        const modalRef = this.modalService.open(TeamShortModal);

        modalRef.componentInstance.team = team;

        let basket: TeamShortDto[] = [];

        switch (basketNumber) {
            case 1:
                basket = this.dto.basket1;
                break;

            case 2:
                basket = this.dto.basket2;
                break;

            case 3:
                basket = this.dto.basket3;
                break;

            case 4:
                basket = this.dto.basket4;
                break;
        }

        modalRef.result.then((result) => {
            if (result) {
                basket[index] = result;
            }
        }, (reason) => { });
    }

    onAddTeam(basketNumber: number) {
        const modalRef = this.modalService.open(TeamShortModal);

        modalRef.componentInstance.team = null;

        let basket: TeamShortDto[] = [];

        switch (basketNumber) {
            case 1:
                basket = this.dto.basket1;
                break;

            case 2:
                basket = this.dto.basket2;
                break;

            case 3:
                basket = this.dto.basket3;
                break;

            case 4:
                basket = this.dto.basket4;
                break;
        }

        modalRef.result.then((result) => {
            if (result) {
                basket.push(result);
            }
        }, (reason) => { });
    }
/*

    doDraw() {

        if (!this.matchDay1 || !this.matchDay2 || !this.matchDay3 || !this.matchDay4  || !this.matchDay5  || !this.matchDay6 ){
            this.notificationService.showError('Не выбраны ИД!');
            return;
        }

        let allTeams = [];

        for (let i=0; i < 4; i++) {
            this.lch[i].forEach(item => {
                allTeams.push(item.id)
            });
            this.lk[i].forEach(item => {
                allTeams.push(item.id)
               });
            this.le[i].forEach(item => {
                allTeams.push(item.id)
               });
        }

        if (new Set(allTeams).size !== allTeams.length) {
            this.notificationService.showError('Среди команд есть дубли!');

            let duplicates = this.findDuplicateTeams(allTeams);

            duplicates.forEach(item =>{
                this.notificationService.showError(item.toString());
            });

            return;
        }

        if (allTeams.length !== 96) {
            this.notificationService.showError('Должно быть 96 команд!');
            return;
        }

        let matchDays = [];
        matchDays.push(this.matchDay1);
        matchDays.push(this.matchDay2);
        matchDays.push(this.matchDay3);
        matchDays.push(this.matchDay4);
        matchDays.push(this.matchDay5);
        matchDays.push(this.matchDay6);

        this.drawingService.drawGroup(matchDays, this.lch, this.le, this.lk)
            .subscribe(result => {
                this.notificationService.showSuccess("Жеребьевка проведелна");
                this.drawingResult = result;
            }, error=> {
                this.notificationService.showError("Error!");
            })

    }*/

    findDuplicateTeams(arr: number[]) {
        let sorted_arr = arr.slice().sort();
        let results = [];
        for (let i = 0; i < sorted_arr.length - 1; i++) {
            if (sorted_arr[i + 1] == sorted_arr[i]) {
            results.push(sorted_arr[i]);
            }
        }
        return results;
    }
}